import { gsap, Quint } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

window.anchorLinks = function() {
  return {
    scrollTo(e) {
      const id = `#${e.target.dataset.ankare}`;
      const state = { id };
      const title = "";
      const url = e.target.dataset.ankarurl;

      history.pushState(state, title, url);
      gsap.to(window, {
        duration: 0.5,
        ease: Quint.easeInOut,
        scrollTo: { y: id },
      });
    },
  };
};
